export const hrpRuleMasterRoutes:{[key:string]:string} = {
    "Hrp Conditions":'/hrp-parameters',
    "Hrp Audit":'/hrp-parameters/audit'
 }